import type { RouteObject } from 'react-router-dom'
import RequireAdmin from '@/components/RequireAdmin'
import Admin from '@/pages/Admin'
import Home from '@/pages/Home'
import Login from '@/pages/Login'
import NewsArticle from '@/pages/NewsArticle'
import NewsList from '@/pages/NewsList'
import { useRoutes } from 'react-router-dom'

export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/noticias', element: <NewsList /> },
  { path: '/noticias/:slug', element: <NewsArticle /> },
  { path: '/login', element: <Login /> },
  {
    path: '/admin',
    element: (
      <RequireAdmin>
        <Admin />
      </RequireAdmin>
    ),
  },
]

function App() {
  return useRoutes(routes)
}

export default App
